module.exports = __webpack_public_path__ + "img/banner-14.c940cda3.jpg";